import React from "react";
import './errorBoundary.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faRotateRight } from '@fortawesome/free-solid-svg-icons';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="sr-error">
          <div className="sr-error__top">
            <div className="sr-error__top-content">
              <div className="sr-error__icon">
                <FontAwesomeIcon icon={faTriangleExclamation} />
              </div>
              <h1 className="sr-error__title">Something went wrong</h1>
              <p className="sr-error__subtitle">An unexpected error occurred. Please try again.</p>
            </div>
          </div>
          <div className="sr-error__body">
            <button type="button" className="sr-error__btn" onClick={this.handleRetry}>
              <FontAwesomeIcon icon={faRotateRight} /> Try Again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
